(function() { module.exports = this["carbon.core"]; }());


//////////////////
// WEBPACK FOOTER
// external "carbon.core"
// module id = 9
// module chunks = 0